/**
 * EmailAutomation ("אוטומציית אימיילים") — route /emailAutomation.
 * The frame for three tabs:
 *   תבניות אימייל   TemplatesManager  — reusable email templates (create / edit / preview / duplicate)
 *   רצפי שליחה      SequencesManager  — multi-step sequences triggered by tags (on/off, stats)
 *   לוח בקרה        Dashboard         — sending stats, queue and logs
 * Each tab owns its data, toolbar and dialogs. See EMAIL_AUTOMATION.md for how sending works.
 */
import React, { useState } from 'react';
import { Page, PageHeader, Tabs } from '../../ui';

import TemplatesManager from './components/TemplatesManager';
import SequencesManager from './components/SequencesManager';
import Dashboard from './components/Dashboard';

const EmailAutomation = () => {
  const [activeTab, setActiveTab] = useState('templates');

  return (
    <Page>
      <PageHeader title="אוטומציית אימיילים" />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          { key: 'templates', label: 'תבניות אימייל', children: <TemplatesManager /> },
          // SequencesManager reloads when its tab becomes active (it gets activeTab)
          { key: 'sequences', label: 'רצפי שליחה', children: <SequencesManager activeTab={activeTab} /> },
          { key: 'dashboard', label: 'לוח בקרה', children: <Dashboard /> },
        ]}
      />
    </Page>
  );
};

export default EmailAutomation;
